const images = [
  "https://customer-assets-agu9un31.emergentagent.net/job_squash-nexus/artifacts/gagf0hqj_image.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_squash-nexus/artifacts/jyq0qsr6_image.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_squash-nexus/artifacts/s3g2gnu8_image.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_squash-nexus/artifacts/y3yxbgr0_image.webp",
];

const ImageStrip = () => (
  <section className="py-1" style={{ background: "var(--lrg-bg)" }} data-testid="image-strip">
    <div className="grid grid-cols-4 gap-1">
      {images.map((src, i) => (
        <div key={src} className="img-hover aspect-[16/9]">
          <img src={src} alt="" className="w-full h-full object-cover" />
        </div>
      ))}
    </div>
  </section>
);

export default ImageStrip;
